import ProInputAdd from "@/components/pro-common/pro-input/pro-input-add.vue";
import ProChioseAddressBook from "@/components/pro-common/pro-chiose-modal/pro-chiose-address-book.vue";
export default {
  name: "member-add-department",
  components: {
    ProInputAdd,
    ProChioseAddressBook
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      }
    },
    title: {
      type: String,
      default() {
        // lg: 选择部门
        return $t("il7c3k4", "选择部门");
      }
    },
    tabs: {
      type: Array,
      default() {
        return ["departmemt"];
      }
    },
    icon: {
      type: String,
      default() {
        return "";
      }
    }
  },
  data() {
    return {
      visible: false,
      inputList: [],
      checkedList: []
    };
  },
  watch: {
    value(val) {
      this.inputList = [...val];
      this.checkedList = [...val];
    }
  },
  methods: {
    close() {
      this.visible = false;
    },
    open() {
      this.checkedList = [...this.inputList];
      this.visible = true;
    },
    onSubmit() {
      this.inputList = [...this.checkedList];
      this.$emit("input", this.inputList);
      this.$emit("onChange", this.inputList);
      this.close();
    }
  }
};